export default __webpack_public_path__ + "media/images/btn-add_v2-6753859af66b54bddad7f9fc75db13be.png";